"use client"

import { BookDashed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookDashedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookDashedIcon = component(Icon)({ as: BookDashed })
